import { makeMainGEvent, pushEvent } from '../../../../utils/analytics';
import { Offer } from '../../Offer';
import image from '../images/tourist.png';

export const Tourist = () => {
  const handleClick = () => {
    pushEvent(
      makeMainGEvent({
        eventCategory: 'ВЗР',
        eventAction: 'Сезонные предложения',
      }),
    );
  };

  return (
    <Offer
      title={'Туристическая страховка\nдля шенгена и визы'}
      subtitle={'Защитит ваше здоровье\nза границей'}
      color="violet"
      image={image}
      href="/vzr/"
      onClick={handleClick}
    />
  );
};
